<template>
  <main-template>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-wrap align-center justify-space-between">
            <div>
              <h1 class="mb-2">
                <v-btn color="primary" x-small text @click="goBack">
                  <v-icon left> fa fa-angle-left </v-icon>
                </v-btn>
                Presenças dos Colaboradores
              </h1>
              <div class="grey--text text--darken-1">
                Acompanhamento automático de registro de ponto registradas hoje pelos colaboradores.
              </div>
            </div>
            <div class="d-flex align-center mt-3 mt-md-0">
              <v-chip class="mr-2" color="green lighten-5" text-color="green darken-2" label>
                {{ totalEventos }} registro(s)
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3">
          <v-card outlined>
            <v-card-text>
              <div class="text-overline">Data</div>
              <div class="text-h6">{{ formattedDate }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card outlined>
            <v-card-text>
              <div class="text-overline">Última atualização</div>
              <div class="text-h6">{{ formattedGeneratedAt }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card outlined>
            <v-card-text>
              <div class="text-overline">Escolas / Unidades</div>
              <div class="text-h6">{{ totalEscolas }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card outlined>
            <v-card-text>
              <div class="text-overline">Colaboradores Presentes</div>
              <div class="text-h6">{{ totalColaboradores }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-alert border="left" colored-border dense outlined type="info" class="mb-0">
            {{ descricaoEscopoVisualizacao }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined :loading="loading">
            <v-card-text v-if="!loading && !escolas.length" class="py-10 text-center">
              <v-icon size="42" color="grey lighten-1">mdi-clock-alert-outline</v-icon>
              <div class="text-h6 mt-4">Nenhum registro de ponto registrada hoje.</div>
              <div class="grey--text text--darken-1">
                Assim que um colaborador registrar o ponto, ele aparecerá aqui automaticamente.
              </div>
            </v-card-text>

            <v-card-text v-else class="pa-2 pa-md-4">
              <v-expansion-panels v-model="openPanels" multiple accordion>
                <v-expansion-panel v-for="escola in escolas" :key="`escola-${escola.escola_id}`">
                  <v-expansion-panel-header>
                    <div class="d-flex flex-wrap align-center justify-space-between w-100 pr-4">
                      <div class="text-subtitle-1 font-weight-bold">
                        {{ escola.escola }}
                      </div>
                      <v-chip small color="primary" outlined>
                        {{ escola.cargos ? escola.cargos.length : 0 }} cargo(s)
                      </v-chip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-expansion-panels
                      v-model="cargoOpenPanels[escola.escola_id]"
                      multiple
                      class="cargo-expansion"
                    >
                      <v-expansion-panel
                        v-for="cargo in escola.cargos"
                        :key="`cargo-${cargo.cargo_id}`"
                        class="mb-3"
                      >
                        <v-expansion-panel-header>
                          <div
                            class="d-flex justify-space-between align-center flex-wrap w-100 pr-4"
                          >
                            <span class="font-weight-medium">{{ cargo.cargo }}</span>
                            <v-chip small color="green lighten-5" text-color="green darken-2">
                              {{ cargo.colaboradores ? cargo.colaboradores.length : 0 }} registro(s)
                            </v-chip>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list two-line>
                            <v-list-item
                              v-for="colaborador in cargo.colaboradores"
                              :key="`registro-${colaborador.id}`"
                              class="colaborador-list-item px-2 py-2"
                            >
                              <v-list-item-avatar
                                size="34"
                                class="colaborador-avatar mr-2"
                                :color="
                                  colaborador.tipo_evento === 'entrada'
                                    ? 'green lighten-5'
                                    : 'blue-grey lighten-5'
                                "
                              >
                                <v-icon
                                  size="18"
                                  :color="
                                    colaborador.tipo_evento === 'entrada'
                                      ? 'green darken-2'
                                      : 'blue-grey darken-1'
                                  "
                                >
                                  {{
                                    colaborador.tipo_evento === "entrada"
                                      ? "mdi-check-circle"
                                      : "mdi-clock-outline"
                                  }}
                                </v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-medium text-wrap colaborador-nome"
                                >
                                  {{ colaborador.nome }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="colaborador-meta">
                                  ID Usuário {{ colaborador.user_id }} | Origem:
                                  {{ colaborador.origem || "Ponto" }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action
                                class="colaborador-action my-0 ml-2 align-self-start"
                              >
                                <v-chip
                                  small
                                  label
                                  class="colaborador-status mb-1"
                                  :color="
                                    colaborador.tipo_evento === 'entrada' ? 'green' : 'blue-grey'
                                  "
                                  text-color="white"
                                >
                                  {{
                                    colaborador.tipo_evento === "entrada" ? "Entrada" : "Registro"
                                  }}
                                </v-chip>
                                <small class="grey--text text--darken-1 colaborador-horario">
                                  {{ formatDateTime(colaborador.data_evento) }}
                                </small>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

const POLLING_INTERVAL = 15000;
const ROLES_COM_VISAO_GERAL = [
  "admin",
  "super-admin",
  "secretario",
  "TI",
  "coordenador",
  "direção",
];

export default {
  name: "IndexPontoFiqColaboradoresPage",
  data() {
    return {
      loading: true,
      refreshing: false,
      poller: null,
      escolas: [],
      date: null,
      generatedAt: null,
      totalEventos: 0,
      totalEscolas: 0,
      totalColaboradores: 0,
      openPanels: [],
      cargoOpenPanels: {},
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    formattedDate() {
      return this.date ? this.formatDate(this.date) : "--/--/----";
    },
    formattedGeneratedAt() {
      return this.generatedAt ? this.formatDateTime(this.generatedAt) : "Aguardando dados";
    },
    podeVerPresencasTodasEscolas() {
      const userRoles = [];
      if (this.user?.roleName) userRoles.push(this.user.roleName);
      if (this.user?.role?.name) userRoles.push(this.user.role.name);
      if (Array.isArray(this.user?.roles)) {
        this.user.roles.forEach((r) => {
          if (r?.name) userRoles.push(r.name);
        });
      }
      return userRoles.some((role) => ROLES_COM_VISAO_GERAL.includes(role));
    },
    franquiasPermitidasIds() {
      const franquiasPermitidas = this.user?.franquias_permitidas;

      if (Array.isArray(franquiasPermitidas)) {
        return franquiasPermitidas.map(Number).filter(Boolean);
      }

      if (typeof franquiasPermitidas === "string") {
        try {
          const parsed = JSON.parse(franquiasPermitidas);
          return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
        } catch (error) {
          return [];
        }
      }

      return [];
    },
    franquiasRestritasIds() {
      const franquiaAtualId = Number(this.user?.franquia?.id);
      const franquiasPermitidasIds = this.franquiasPermitidasIds;

      if (franquiasPermitidasIds.length) {
        return franquiasPermitidasIds;
      }

      return franquiaAtualId ? [franquiaAtualId] : [];
    },
    descricaoEscopoVisualizacao() {
      if (this.podeVerPresencasTodasEscolas) {
        return "Visualizando pontos de todas as unidades dos colaboradores.";
      }

      if (this.franquiasRestritasIds.length > 1) {
        return `Visualizando pontos das unidades vinculadas ao usuário (${this.franquiasRestritasIds.length} unidades).`;
      }

      return `Visualizando pontos da unidade vinculada ao usuário: ${
        this.user?.franquia?.descricao || "unidade permitida"
      }.`;
    },
  },
  async mounted() {
    await this.refresh({ silent: false });
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    goBack() {
      if (this.user?.roleName === "professor" || this.user?.role?.name?.includes("professor")) {
        this.$router.push({
          name: "acessoProfessor.home",
        });
        return;
      }
      this.$router.push({
        name: "home",
      });
    },
    startPolling() {
      this.stopPolling();
      this.poller = setInterval(() => {
        this.refresh({ silent: true });
      }, POLLING_INTERVAL);
    },
    stopPolling() {
      if (this.poller) {
        clearInterval(this.poller);
        this.poller = null;
      }
    },
    async refresh({ silent }) {
      if (silent) {
        this.refreshing = true;
      } else {
        this.loading = true;
      }

      try {
        const response =
          await this.$services.colaboradorPontosService.listPresencasNotifiqColaboradores();
        const escolasFiltradas = this.filtrarEscolasPorPerfil(response.escolas || []);
        const totais = this.calcularTotais(escolasFiltradas);

        this.escolas = escolasFiltradas;
        this.date = response.date || null;
        this.generatedAt = response.generated_at || null;
        this.totalEventos = totais.totalEventos;
        this.totalEscolas = totais.totalEscolas;
        this.totalColaboradores = response.total_colaboradores || totais.totalColaboradores;

        if (this.escolas.length) {
          this.openPanels = this.escolas.map((_, index) => index);
        } else {
          this.openPanels = [];
        }

        this.escolas.forEach((escola) => {
          if (!Array.isArray(this.cargoOpenPanels[escola.escola_id])) {
            this.$set(
              this.cargoOpenPanels,
              escola.escola_id,
              (escola.cargos || []).map((_, index) => index)
            );
          }
        });
      } catch (error) {
        if (!silent) {
          this.$handleError(error);
        }
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    filtrarEscolasPorPerfil(escolas) {
      if (this.podeVerPresencasTodasEscolas) {
        return escolas;
      }

      const franquiasPermitidasIds = this.franquiasRestritasIds;

      if (!franquiasPermitidasIds.length) {
        return [];
      }

      return escolas.filter((escola) => franquiasPermitidasIds.includes(Number(escola.escola_id)));
    },
    calcularTotais(escolas) {
      let totalEventos = 0;
      const colaboradoresUnicos = new Set();

      escolas.forEach((escola) => {
        (escola.cargos || []).forEach((cargo) => {
          (cargo.colaboradores || []).forEach((colab) => {
            totalEventos++;
            if (colab.user_id) colaboradoresUnicos.add(colab.user_id);
          });
        });
      });

      return {
        totalEventos,
        totalEscolas: escolas.length,
        totalColaboradores: colaboradoresUnicos.size,
      };
    },
    formatDate(value) {
      if (!value) return "--/--/----";

      const date = this.parseDateValue(value);
      if (Number.isNaN(date.getTime())) return "--/--/----";

      return date.toLocaleDateString("pt-BR");
    },
    formatDateTime(value) {
      if (!value) return "--";

      const date = this.parseDateValue(value);
      if (Number.isNaN(date.getTime())) return "--";

      return date.toLocaleString("pt-BR");
    },
    parseDateValue(value) {
      if (!value) return new Date(NaN);

      if (value instanceof Date) {
        return value;
      }

      const normalizedValue = String(value).trim();
      const match = normalizedValue.match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
      );

      if (match) {
        const [, year, month, day, hour = "00", minute = "00", second = "00"] = match;

        return new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute),
          Number(second)
        );
      }

      return new Date(normalizedValue);
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}

.cargo-expansion {
  background: transparent;
}

.colaborador-list-item {
  align-items: flex-start;
  min-height: 72px;
}

.colaborador-avatar {
  min-width: 34px;
  margin-top: 2px;
}

.colaborador-nome {
  font-size: 0.88rem;
  line-height: 1.25rem;
}

.colaborador-meta {
  font-size: 0.76rem;
  line-height: 1.05rem;
  white-space: normal;
}

.colaborador-action {
  min-width: 92px;
  align-items: flex-end;
}

.colaborador-status {
  font-size: 0.72rem;
}

.colaborador-horario {
  font-size: 0.72rem;
  line-height: 0.95rem;
  text-align: right;
  max-width: 92px;
  white-space: normal;
}

@media (max-width: 600px) {
  .colaborador-list-item {
    min-height: 78px;
  }

  .colaborador-nome {
    font-size: 0.82rem;
    line-height: 1.15rem;
  }

  .colaborador-meta {
    font-size: 0.74rem;
    line-height: 1rem;
  }

  .colaborador-action {
    min-width: 84px;
  }

  .colaborador-status {
    font-size: 0.68rem;
  }

  .colaborador-horario {
    font-size: 0.7rem;
    line-height: 0.9rem;
    max-width: 84px;
  }
}
</style>
